import { IMenuItem } from 'Components/MenuTop/MenuTop';

interface IMenuTopContent {
  buttonContact: IMenuItem;
  buttonOrganizer: IMenuItem;
  buttonVoucher: IMenuItem;
  buttonMyPage: IMenuItem;
}

export const staticContent: IMenuTopContent = {
  buttonContact: { 
    displayName: 'Kontakt',
    formattedName: 'menu.contact',
    localPath: '/information/kontakt', 
    backgroundColor: 'transparent', 
    iconType: 'question-circle-o', 
  },
  buttonOrganizer: { 
    displayName: 'Arrangör',
    formattedName: 'menu.organizer',
    localPath: '/arrangör', 
    backgroundColor: 'transparent', 
    iconType: 'solution', 
  },
  buttonVoucher: { 
    displayName: 'Presentkort',
    formattedName: 'menu.voucher',
    localPath: '/order/presentkort', 
    backgroundColor: 'purple', 
    iconType: 'gift', 
  },
  buttonMyPage: { 
    displayName: 'Min sida',
    formattedName: 'menu.mypage',
    backgroundColor: 'red', 
    iconType: 'star-o', 
  },
};


// WEBPACK FOOTER //
// ./src/components/MenuTop/MenuTopContent.tsx